<template>
  <b-button pill variant="secondary" :disabled="modalDisabled || processing" @click="certify" class="w-100 w-lg-auto" aria-label="Open certification modal">
    Certify
    <b-modal
      ref="certifyConfirmation"
      content-class="px-lg-5"
      id="certifyConfirmation"
      title="Certify and Submit"
      footer-class="text-center"
      centered
      hide-header-close
      size="lg"
    >
      <b-form-checkbox
        id="correctnessAcknowledgement"
        class="mb-3"
        v-model="correctnessAcknowledgement"
      >
        <span class='custom-checkbox-label'>I hereby certify that the information herein is accurate and complete to the best of my knowledge.</span>
      </b-form-checkbox>
      <b-form-checkbox
        id="submissionAcknowledgement"
        class="mb-3"
        v-model="submissionAcknowledgement"
      >
        <span class='custom-checkbox-label'>I understand that I will not be able to make changes to this report once submitted.</span>
      </b-form-checkbox>
      <b-form-checkbox id="privacyAcknowledgement" class="mb-3" v-model="privacyAcknowledgement">
        <span class='custom-checkbox-label'>I understand that the information contained in this landowner report may not be made public, except that summary reports may be published that use aggregated data that do not reveal the activities of an individual person or firm.
        <a :href="links.statute12" target="_blank" rel="noopener noreferrer">More information</a>
        </span>
      </b-form-checkbox>
      <b-form-checkbox
        v-if="finalYearAcknowledgementRequired"
        id="finalYearAcknowledgement"
        class="mb-3"
        v-model="finalYearAcknowledgement"
      >
        <span class='custom-checkbox-label'>I understand that if harvest activity continues beyond {{notification.operationEndDate | dateString}}, the FON end date, I MUST file a new FON for the additional harvesting, because <strong>a FON cannot be extended</strong>.</span>
      </b-form-checkbox>
      <div slot="modal-footer" class="d-flex">
        <b-button pill variant="danger" :disabled="processing" class="mr-3" @click="hideModal" aria-label="Cancel certification">
          Cancel
        </b-button>
        <b-button pill :disabled="!acknowledged || processing" @click="certified()" aria-label="Confirm certification">
          Certify and Submit
        </b-button>
      </div>
    </b-modal>
  </b-button>
</template>

<script>
import { mapState } from 'vuex';
import Utilities from '@/mixins/Utilities';

const initialState = () => ({
  correctnessAcknowledgement: false,
  submissionAcknowledgement: false,
  privacyAcknowledgement: false,
  finalYearAcknowledgement: false,
  // processing is used to disable the certify buttons while the api call is doing its thing
  processing: false,
});

export default {
  name: 'CertifyModal',
  mixins: [Utilities],
  props: {
    modalDisabled: {
      type: Boolean,
      default: true,
    },
    isAdminEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return initialState();
  },
  computed: {
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState('LandownerReport', {
      landownerReport: state => state.landownerReport,
    }),
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    acknowledged() {
      return this.correctnessAcknowledgement
        && this.submissionAcknowledgement
        && this.privacyAcknowledgement
        && (!this.finalYearAcknowledgementRequired || this.finalYearAcknowledgement);
    },
    finalYearAcknowledgementRequired() {
      return this.landownerReport.isFinalYear && !this.landownerReport.harvestComplete;
    },
  },
  methods: {
    certify() {
      Object.assign(this.$data, initialState());
      this.$refs.certifyConfirmation.show();
    },
    async certified() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      if (this.isAdminEdit) {
        await this.$store.dispatch(
          'LandownerReport/adminSubmitEdit',
          this.landownerReport.id,
        );
      } else {
        await this.$store.dispatch(
          'LandownerReport/submit',
          this.landownerReport.id,
        );
      }
      this.processing = false;
      this.$emit('certified');
    },
    hideModal() {
      this.$refs.certifyConfirmation.hide();
    },
  },
};
</script>
